import _ from 'lodash';
import { formatUrlDomain, getDomains } from 'portal-common/helpers/domainUtils';

import { isBrowser } from './device';
import { addParamsToUrl } from './url';

const parseUrl = (srcUrl) => {
  let protocol;
  let host;
  let path;

  if (srcUrl && /^((?:https?:)?\/\/)([^/]+)(\/.*)?$/.test(srcUrl.trim())) {
    protocol = RegExp.$1;
    host = RegExp.$2;
    path = RegExp.$3;
  } else {
    protocol = '';
    host = '';
    path = srcUrl;
  }

  const ret = {
    protocol,
    host,
    path,
  };

  return ret;
};

export const BASE_HOSTS = {
  QCMAIN_HOST: 'intl.cloud.tencent.com',
  QCMAIN_NEW_HOST: 'www.tencentcloud.com',
  QCCONSOLE_HOST: 'console.intl.cloud.tencent.com',
  QCCONSOLE_CN_HOST: 'console.cloud.tencent.com',
  QCBUY_HOST: 'buy.intl.cloud.tencent.com',
  QCBUY_CN_HOST: 'buy.cloud.tencent.com',
  CHINA_HOST: 'cloud.tencent.com', // 中国站域名。在国际站域名修改后会和国际站域名、cookie域名区分开，单独处理
};

export const MAIN_HOSTS = ['intl.cloud.tencent.com', 'www.tencentcloud.com'];

export const MAIN_DOMAINS = ['intl.cloud.tencent.com', 'www.tencentcloud.com'];

export const BASE_DOMAINS = [
  'qcloud.com',
  'cloud.tencent.com.cn',
  'cloud.tencent.cn',
  'cloud.tencent.com',
  'tencentcloud.com',
];

// const hostRegex = new RegExp(`${Object.values(MAIN_DOMAINS).join('|')}`);

export function getRealHostName() {
  if (isBrowser()) {
    const { hostname } = location;
    const result = _.find(Object.values(BASE_HOSTS), (i) => {
      return hostname.includes(i);
    });
    return result ? hostname : 'intl.cloud.tencent.com';
  }
  return global ? global.originHost : 'intl.cloud.tencent.com';
}

export function getCookieDomain() {
  if (isBrowser()) {
    const { hostname } = location;
    const result = _.find(BASE_DOMAINS, (i) => hostname.includes(i));
    return result || 'cloud.tencent.com';
  }
  return global ? global.cookieDomain : 'cloud.tencent.com';
}

export function getCDNDomain() {
  return 'cloudcache.tencent-cloud.com' || 'imgcache.qq.com';
}

export function formatUrlHost(srcUrl) {
  const { protocol, host, path } = parseUrl(srcUrl);
  let handledHost = host;
  handledHost = handledHost.replace(/^www\.tencentcloud\.com$/, 'intl.cloud.tencent.com');
  handledHost = handledHost.replace(/^tencentcloud\.com$/, 'intl.cloud.tencent.com');
  let handledUrl = `${protocol}${handledHost}${path}`;
  const realHost = getRealHostName();
  const domainInfos = getDomains(realHost);
  handledUrl = formatUrlDomain(handledUrl, { domainInfos });
  return handledUrl;
}

export function isSafeHost(srcUrl) {
  const { host } = parseUrl(decodeURIComponent(srcUrl));
  const result = _.find(Object.values(BASE_HOSTS), (i) => {
    return host.includes(i);
  });
  return !!result;
}

export function validURL(sUrl) {
  return !!(
    /^(https?:\/\/)?[\w\-.]+\.(tencent|tencentcloud)\.com($|\/|\\)/i.test(sUrl) ||
    /^[\w][\w/.\-_%]+$/i.test(sUrl) ||
    /^[/\\][^/\\]/i.test(sUrl)
  );
}

/**
 * 获取对应当前host的完成url
 */

export function getRealUrl(path = '', query = {}) {
  const hostname = getRealHostName();
  return addParamsToUrl(`https://${hostname}${path}`, query);
}
